import { z } from 'zod';
import { defineEvents } from '@ndrc/app-sdk/events';
import fr from './messages/fr.json' with { type: 'json' };
export const events = defineEvents({
  'team.forecast.published': {
    schema: z.object({
      planId: z.uuid(),
      planVersion: z.string().min(1).max(160),
      name: z.string().min(1).max(160),
      period: z.object({ from: z.iso.date(), to: z.iso.date() }),
      justification: z.string().min(10).max(1000),
      publishedAt: z.iso.datetime(),
      totals: z.object({
        scheduledMinutes: z.number().nonnegative(),
        productiveMinutes: z.number().nonnegative(),
        requiredMinutes: z.number().nonnegative(),
        demand: z.number().nonnegative(),
        cost: z.number().nonnegative(),
        overloadMinutes: z.number().nonnegative(),
        advisors: z.number().int().nonnegative(),
      }),
    }),
    journal: { label: fr.forecastEvent, importance: 'normal' },
    realtime: true,
  },
  'team.plan.changed': {
    schema: z.object({
      planId: z.uuid(),
      action: z.enum(['saved', 'prepared']),
      advisors: z.number().int().min(0),
      slots: z.number().int().min(0),
    }),
    journal: { label: fr.event, importance: 'normal' },
    realtime: true,
  },
});
